import map from 'lodash/map'
import React from 'react'

import { TopLink } from '@Blocks/ProductList/Components/TopLink/types'
import { Link } from '@Components/Link'
import { SliderWithArrowsAndIndicator } from '@Components/Slider/SliderWithArrowsAndIndicator'
import { TilesCardGeneric } from '@Components/Tiles/Card/Generic'
import { PagePresentation } from '@Generated/graphql'
import { pageTypeToDestinationPageType } from '@Globals/Page/Mappers'

import styles from './Slider.module.scss'

export const TopLinksSlider = ({
  items,
}: {
  items: TopLink[]
}) => (
  <div className={styles.sliderWrapper}>
    <SliderWithArrowsAndIndicator
      className={styles.sliderContainer}
      hideArrows
      sliderClassName={styles.slider}
    >
      {map(items, (item) => {
        if (!item.type || !item.url) {
          return null
        }

        return (
          <Link
            key={item.id!}
            analytics={{
              dest_page_type: pageTypeToDestinationPageType(item.type),
              dest_page_type_id: item.id || '',
              source_id: 'top_links',
            }}
            className={styles.slide}
            draggable={false}
            href={item.url}
          >
            <TilesCardGeneric
              appearance={{
                backgroundColor: '#F1EBE4',
                textColor: 'var(--black)',
              }}
              cardAspectRatio="square"
              cardSize="medium"
              cardVariant="toplink"
              disableLinks
              height={80}
              image={item.image?.url || undefined}
              presentation={PagePresentation.Full}
              title={item.title}
              width={80}
            />
          </Link>
        )
      })}
    </SliderWithArrowsAndIndicator>
  </div>
)
